module.exports = __webpack_public_path__ + "img/chatu.f3b41eba.png";